import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-info-circle",
  "use": "foquz-icon-info-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" id=\"foquz-icon-info-circle\"><path d=\"M16.391 12.062a7.999 7.999 0 10-14.78-6.123 7.999 7.999 0 0014.78 6.123z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /><path d=\"M9 8v5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><circle cx=\"9\" cy=\"5\" r=\"1\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol